<template>
    <div class="home">
        <b-container fluid>
            <h1 class="mb-3">Select a Data Report</h1>
            <b-row>
                <b-col>
                    <router-link to="/product-select">
                        <b-button variant="secondary">
                            <b-icon-box-arrow-in-left/>Return to Category Selection
                        </b-button>
                    </router-link>
                </b-col>
            </b-row>
            <b-row class="mt-4">
                <b-col>
                  <a href="https://www.health.state.mn.us/people/vitalrecords/requestdata.html#standard" class="mdh-green-link">
                    Learn what data is included
                  </a> in the data reports. <br><br>
                  Contact the Office of Vital Records to request a custom data report.
                </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col>
                <router-link :to="{name: 'data-product-birth'}">
                  <b-card
                      class="order-card"
                      border-variant="primary"
                      header="Birth record data report"
                      header-class="text-left"
                      header-bg-variant="primary"
                      header-text-variant="white"
                      align="left"
                  >
                    <b-card-text class="no-decoration">
                      Public data from Minnesota birth records for a specified calendar year. Available from 2011 to the present.
                      The report will provide a preliminary dataset when a statistical dataset is unavailable.
                    </b-card-text>
                    <b-card-text class="no-decoration">
                      <b>Price:</b> $15
                    </b-card-text>
                  </b-card>
                </router-link>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <router-link :to="{name: 'data-product-death'}">
                  <b-card
                      class="order-card"
                      border-variant="primary"
                      header="Death record data report"
                      header-class="text-left"
                      header-bg-variant="primary"
                      header-text-variant="white"
                      align="left"
                  >
                    <b-card-text class="no-decoration">
                      Data from Minnesota death records for a specified calendar year. Available from 2011 to the present.
                      The report will provide a preliminary dataset when a statistical dataset is unavailable.
                    </b-card-text>
                    <b-card-text class="no-decoration">
                      <b>Price:</b> $15
                    </b-card-text>
                  </b-card>
                </router-link>
              </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import LocalStorageService from "@/common/LocalStorageService";


    const localStorageService = LocalStorageService.getService();

    export default {
        data: () => ({
            details: {
                orderId: null,
                product: null,
                year: null,
                quantity: 1,
            },
            dataFileOptions: [],
            yearOptions: [],
            currentYear: new Date().getFullYear(),
        }),

        created() {
            document.title = "Select a Data Report - OVR Storefront"
        },

    }
</script>

<style>
    .green-header {
        color: #60A609;
    }
</style>
